<template lang="pug">
  .container(v-if='items' id="ShortScreenList-container")
    .row(v-for="item in items", :key="item.id", :class="{ selected: isSelected(item) }", @click='toggleItemInSelected(item)', :id="'ShortScreenList-row' + item.id" )
      .thumb-container
        img.thumbnail(v-if='getScreenShotURI(item).length > 0', :src='getScreenShotURI(item)')
      span.medium-name {{ assembleDeviceName(item) }}
</template>

<script>
// import ListItemMixin from '../Medium/ListItem.mixin'
import deviceUtils from './deviceUtils.mixin'
export default {
  props: {
    'items': {
      required: true
    },
    showThumbs: {
      required: false,
      default: () => {
        return false
      }
    },
    showMediaIcons: {
      required: false,
      default: () => {
        return false
      }
    }
  },
  components: {
  },
  mixins: [
    // ListItemMixin,
    deviceUtils
  ],
  created () {
    this.selectedItems = JSON.parse(JSON.stringify(this.items))
  },
  watch: {
    items: async function (newVal, oldVal) {
      this.selectedItems = JSON.parse(JSON.stringify(this.items))
    }
  },
  data () {
    return {
      errors: {},
      selectedItems: []
    }
  },
  methods: {
    assembleDeviceName (desktop) {
      let devicename
      if (!isNaN(desktop.Device)) {
        const device = this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
        devicename = device ? device.name : this.$t('unknown device')
      } else {
        devicename = desktop.Device.name ? desktop.Device.name : this.$t('unknown device')
      }
      return devicename + ' - ' + desktop.name
    },
    method (params) {
    },
    isSelected (item) {
      return this.selectedItems.findIndex(is => is.id === item.id) > -1
    },
    toggleItemInSelected (item) {
      const itemInSelectedIndex = this.selectedItems.findIndex(is => is.id === item.id)
      if (this.selectedItems.length === this.items.length) {
        this.selectedItems = []
        this.selectedItems.push(item)
        return
      }
      if (itemInSelectedIndex > -1) {
        this.selectedItems.splice(itemInSelectedIndex, 1)
      } else {
        this.selectedItems.push(item)
      }
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container {
    display: flex;
    flex-direction: column;
    .row {
      padding: 10px 10px;
      border-bottom:  $--border-light;
      cursor: pointer;
      color: $--color-text-secondary;
      font-size: $--font-size-small;
      display: flex;
      align-items: center;
      &.selected {
        font-weight: bold;
        color: $--color-text-primary;
        background-color:  $--background-color-selected;
      }
      .medium-name {
        max-width: 100%;
        overflow: hidden;
      }
      .thumb-container {
        width: 60px;
        .thumbnail {
          max-width: 30px;
          max-height: 30px;
        }
      }
      .icon {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/ShortScreenList.vue